import { Link, useNavigate } from "react-router-dom";

function ProceedOptions() {
  const navigate = useNavigate();

  return (
    <div className="mt-8">
      Riprova con un altra azione. Se il problema persiste, puoi:
      <ul className="list-disc pl-2 my-2">
        {/* <li>
          Ritorna a {" "}
          <span className="link cursor-pointer" onClick={() => navigate(-1)}>
            Pagina precedente
          </span>
          ;
        </li> */}
        <li>
          Vai in <Link to="/">homepage</Link>;
        </li>
      </ul>
      E continua a explorare la nostra collezione.
    </div>
  );
}

export default ProceedOptions;
